import { Box, Typography, List, ListItem } from "@mui/material";
import React from "react";
import data from "../../Assets/data/comissionedworks.json";
const WorksSection = React.forwardRef((props, ref) => {
  return (
    <>
      <Box ref={ref}>
        <Typography
          style={{ margin: "24px 0px 0px" }}
          fontSize="32px"
          fotnWeight={800}
        >
          Commisioned Works
        </Typography>
        <List>
          {data.map((work, i) => {
            return (
              <ListItem
                key={i}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                <Typography fontWeight={600} fontSize="18px">
                  {work.title}
                </Typography>
                <Typography>{work.authors}</Typography>
                <Typography fontSize="14px">{work.year}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Box>
    </>
  );
});

export default WorksSection;
